/* ECOLOR — Lenis integration for Impact. Touch scrolling stays native. */
(function () {
  'use strict';

  if (window.ecolorSmoothScroll || typeof window.Lenis !== 'function' || window.Shopify?.designMode) return;

  var root = document.documentElement;
  var body = document.body;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var nativeScrollAreas = '[role="dialog"], .drawer, .popover, .pswp, .ecolor-ar__modal, .mega-menu, .dropdown-menu--restrictable, .product-gallery__thumbnail-list, .product-gallery__thumbnail-list-wrapper, input, textarea, select, [contenteditable="true"], [data-lenis-prevent]';
  var lenis = null;
  var frameId = 0;
  var galleryOpen = Boolean(document.querySelector('.pswp'));

  function cancelFrame() {
    window.cancelAnimationFrame(frameId);
    frameId = 0;
  }

  function render(time) {
    frameId = 0;
    if (!lenis || document.hidden) return;
    lenis.raf(time);
    if (lenis.isScrolling === 'smooth') frameId = window.requestAnimationFrame(render);
  }

  function wake() {
    if (frameId || !lenis || lenis.isStopped || document.hidden) return;
    // Rebase the clock before starting an animation after an idle interval.
    lenis.raf(performance.now());
    frameId = window.requestAnimationFrame(render);
  }

  function interrupt() {
    if (!lenis || lenis.isStopped || lenis.isScrolling !== 'smooth') return;
    lenis.scrollTo(lenis.actualScroll, { immediate: true });
    cancelFrame();
  }

  function hasInlineLock(element) {
    return element.style.overflowY === 'hidden' || element.style.overflowY === 'clip';
  }

  function syncLock() {
    if (!lenis) return;
    // Use Impact's own lock and the AR viewer's inline lock; avoid layout reads
    // on every animation frame and never treat Lenis's own class as a lock.
    var locked = root.classList.contains('lock') || body.classList.contains('lock') ||
      hasInlineLock(root) || hasInlineLock(body) || galleryOpen;
    if (locked) {
      lenis.stop();
      cancelFrame();
    } else if (lenis.isStopped) {
      lenis.start();
    }
  }

  function destroy() {
    cancelFrame();
    if (lenis) lenis.destroy();
    lenis = null;
  }

  function setup() {
    if (reducedMotion.matches) {
      destroy();
      return;
    }
    if (lenis) return;
    lenis = new window.Lenis({
      lerp: 0.1,
      smoothWheel: true,
      syncTouch: false,
      autoRaf: false,
      // Impact owns anchor clicks. Its two page-scroll actions use the adapter
      // below, preserving the existing URL behavior and sticky-header offset.
      anchors: false,
      prevent: function (node) { return node.matches(nativeScrollAreas); },
      virtualScroll: function (data) {
        if (data.event.defaultPrevented || data.event.shiftKey || Math.abs(data.deltaX) > Math.abs(data.deltaY)) {
          interrupt();
          return false;
        }
        return true;
      }
    });
    lenis.on('virtual-scroll', function (data) {
      if (data.event.type === 'wheel') wake();
    });
    galleryOpen = Boolean(document.querySelector('.pswp'));
    syncLock();
  }

  window.ecolorSmoothScroll = {
    scrollTo: function (target) {
      if (!lenis || lenis.isStopped || target.closest(nativeScrollAreas)) return false;
      wake();
      lenis.scrollTo(target);
      return true;
    }
  };

  // Observe only the two page containers. No full-page subtree observer or
  // nested-scroll layout scan is needed for the theme's existing components.
  var locks = new MutationObserver(function (records) {
    if (records.some(function (record) { return record.type === 'childList'; })) {
      galleryOpen = Boolean(document.querySelector('.pswp'));
    }
    syncLock();
  });
  locks.observe(root, { attributes: true, attributeFilter: ['class', 'style'] });
  locks.observe(body, { attributes: true, attributeFilter: ['class', 'style'], childList: true });

  reducedMotion.addEventListener('change', setup);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      interrupt();
      cancelFrame();
    }
  });
  document.addEventListener('focusin', interrupt);
  window.addEventListener('keydown', function (event) {
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) interrupt();
  });
  window.addEventListener('hashchange', interrupt);
  window.addEventListener('pagehide', destroy);
  window.addEventListener('pageshow', setup);

  setup();
})();
